import React from 'react';

const History_of_AI = () => {
    return (
        <div>History_of_AI Component</div>
    );
}

export default History_of_AI;
